export default function checkChar(value) {
    let regex = null;
    const language = this.lang;
    regex = language === 'english' ? /^[ A-Za-z0-9_@./#&+-]*$/ : /[\u0600-\u06FF\u0750-\u077F ]/;
    return regex.test(value);
}